import axios from 'axios';
import BankIdEntity from './bank-id-entity';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import PendingRequestEntity from '../entities/pending-request-entity';

class BankIdService {

  hydrate (data) {
    return new BankIdEntity(
      data.session_id,
      data.redirect_url,
      data.autostart,
    );
  }

  requestLogin (socialSecurityNr, email) {
    let pendingRequest = new PendingRequestEntity();

    pendingRequest.promise = axios.post('backend://bankid/login', {
      data: {
        attributes: {
          social_security_number: socialSecurityNr,
          email: email
        }
      }
    }, {
      cancelToken: new axios.CancelToken(function executor (c) {
        pendingRequest.cancel = c;
      })
    }).then((response) => {
      if (response.data.data) {
        return this.hydrate(response.data.data.attributes);
      }
      return null;
    });

    return pendingRequest;
  }

  getErrors (error) {
    if (error) {
      let errorMessages = [proxyCounterpart('BANKID_GENERAL_ERROR')];
      if (errorMessages.length > 0) {
        return {messages: errorMessages};
      }
    }
    return false;
  }
}

export default new BankIdService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/bank-id/bank-id-service.js
 **/